import { BackendConfigSettingsInterface } from 'common/data/backend/config/settings.interface';

export function settingsGetPageType(settings: BackendConfigSettingsInterface): string {
  return settings.gtm ? settings.gtm.pageType : 'Static';
}
